<template>
  <div class="vacancy-edit-characteristics">
    <div :class="isFilledSchedule ? '_done' : null"
         class="vacancy-edit-characteristics__section">
      <div class="vacancy-edit-characteristics__section-head">
        <div class="vacancy-edit-characteristics__title-wrap">
          <div class="vacancy-edit-characteristics__ico">
            <BaseSvg name="ico-calendar" width="1.2rem" height="1.2rem"/>
          </div>
          <h3 class="vacancy-edit-characteristics__title">{{$tNewVacancy('Schedule')}}</h3>
        </div>
      </div>
      <VacancyEditCharacteristicsSchedule/>
    </div>
    <div :class="isFilledSalary ? '_done' : null"
         class="vacancy-edit-characteristics__section">
      <div class="vacancy-edit-characteristics__section-head">
        <div class="vacancy-edit-characteristics__title-wrap">
          <div class="vacancy-edit-characteristics__ico">
            <BaseSvg name="ico-wallet" width="1.2rem" height="1.2rem"/>
          </div>
          <h3 class="vacancy-edit-characteristics__title">{{$tNewVacancy('Salary')}}</h3>
        </div>
      </div>
      <VacancyEditCharacteristicsSalary/>
    </div>
    <div :class="isFilledInhabitancy ? '_done' : null"
         class="vacancy-edit-characteristics__section">
      <div class="vacancy-edit-characteristics__section-head">
        <div class="vacancy-edit-characteristics__title-wrap">
          <div class="vacancy-edit-characteristics__ico">
            <BaseSvg name="ico-house" width="1.2rem" height="1.2rem"/>
          </div>
          <h3 class="vacancy-edit-characteristics__title">{{$tNewVacancy('Housing')}}</h3>
        </div>
      </div>
      <VacancyEditCharacteristicsInhabitancy/>
    </div>
    <VacancyEditCharacteristicsDynamic/>
    <div class="vacancy-edit-characteristics__section">
      <div class="vacancy-edit-characteristics__section-head">
        <div class="vacancy-edit-characteristics__title-wrap">
          <div class="vacancy-edit-characteristics__ico">
            <BaseSvg name="ico-plus" width="1.2rem" height="1.2rem"/>
          </div>
          <h3 class="vacancy-edit-characteristics__title">{{$tNewVacancy('Additionally')}}</h3>
        </div>
      </div>
      <VacancyEditCharacteristicsAdditional/>
    </div>
  </div>
</template>

<script>
  import VacancyEditCharacteristicsSchedule from './VacancyEditCharacteristicsSchedule'
  import VacancyEditCharacteristicsSalary from './VacancyEditCharacteristicsSalary'
  import VacancyEditCharacteristicsInhabitancy from './VacancyEditCharacteristicsInhabitancy'
  import VacancyEditCharacteristicsDynamic from './VacancyEditCharacteristicsDynamic'
  import VacancyEditCharacteristicsAdditional from './VacancyEditCharacteristicsAdditional'

  export default {
    components: {
      VacancyEditCharacteristicsSchedule,
      VacancyEditCharacteristicsSalary,
      VacancyEditCharacteristicsInhabitancy,
      VacancyEditCharacteristicsDynamic,
      VacancyEditCharacteristicsAdditional
    },
    props: {},
    data() {
      return {

      }
    },
    computed: {
      // ...mapState('vacancyEdit', {
      //   inputsSchedule: 'characteristicsSchedule/inputs',
      //   inputsSalary: 'characteristicsSalary/inputs',
      //   inputsInhabitancy: 'characteristicsInhabitancy/inputs',
      // }),
      isFilledSchedule() {
        return !!this.$store.state.vacancyEdit.characteristicsSchedule.inputs.type.value
      },
      isFilledSalary() {
        return !!this.$store.state.vacancyEdit.characteristicsSalary.inputs.char_salary_type_id.value
      },
      isFilledInhabitancy() {
        return !!this.$store.state.vacancyEdit.characteristicsInhabitancy.inputs.char_inhabitancy_type_id.value
      }
    },
    methods: {

    },
    created() {

    }
  }
</script>

<style lang="less">

</style>
